import {IWorkzone} from "mhc-server/dist/interfaces";

import {getBrowserDbWorkzonesCollection} from "./getBrowserDbWorkzonesCollection";

export const browserDbWorkzoneLoad = async (companyId: string, userId: string, id: string): Promise<IWorkzone | null> => {
  const collection = getBrowserDbWorkzonesCollection(companyId, userId);
  return collection.get(id);
};
